import { render, staticRenderFns } from "./DetailedExperience.vue?vue&type=template&id=d5487492&scoped=true&"
import script from "./DetailedExperience.vue?vue&type=script&lang=js&"
export * from "./DetailedExperience.vue?vue&type=script&lang=js&"
import style0 from "./DetailedExperience.vue?vue&type=style&index=0&id=d5487492&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5487492",
  null
  
)

export default component.exports